<div class="d-flex flex-column align-items-center text-center p-4">
  @if (icon) {
    <div class="icon-wrapper d-flex justify-content-center align-items-center mb-4">
      <img [src]="icon" alt="icon" class="img-fluid" />
    </div>
  }

  <h4 class="title-placeholder">{{ title | translate }}</h4>
  <p class="sub-title-placeholder">{{ subTitle | translate }}</p>

  @if (showButton === 'true') {
    <app-button
      [class]="'btn-placeholder'"
      [label]="buttonLabel | translate"
      [color]="'primary'"
      (click)="onAction()"
    ></app-button>
  }
</div>
